import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import Notification from 'pages/Notification'

const notificationsSearchSchema = z.object({
  tab: z
    .enum([
      'all',
      'logger_stopped',
      'cable_disconnected',
      'errors_in_data',
      'incorrect_number_sensors',
      'no_cable_data',
    ])
    .optional()
    .default('all'),
})

const notificationsSearchDefaults = { tab: 'all' } as const

export const Route = createFileRoute('/_auth/_global/notifications')({
  component: Notification,
  validateSearch: zodValidator(notificationsSearchSchema),
  search: {
    middlewares: [stripSearchParams(notificationsSearchDefaults)],
  },
})
